/* KODA Event RSVP form
   Sends each submission to: Google Sheet (Apps Script, source of truth + duplicate check),
   Klaviyo (client "Event RSVP" event, plus newsletter subscription), and GTM (dataLayer). */
(function () {
  if (window.__kodaRsvp) return;
  window.__kodaRsvp = true;

  var KLAVIYO_REVISION = '2024-10-15';

  function makeRef(prefix) {
    var t = Date.now().toString(36);
    var r = Math.random().toString(36).slice(2, 5);
    return (prefix + '-' + (t.slice(-4) + r)).toUpperCase();
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{([a-z_]+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    }).replace(/,\s*$/, '');
  }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerOffset() {
    var h = document.querySelector('sticky-header, .header-wrapper, .section-header');
    var r = h ? h.getBoundingClientRect() : null;
    return (r && r.bottom > 0 ? r.bottom : 0) + 24;
  }

  function icsDate(iso) {
    /* "2026-10-20T07:30:00Z" -> "20261020T073000Z" */
    return String(iso || '').replace(/[-:]/g, '').replace(/\.\d+/, '');
  }

  function icsEscape(v) {
    return String(v || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
  }

  function downloadIcs(ev, ref) {
    var lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//KODA Lighting//Events//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + (ref || Date.now()) + '@kodalighting.com.au',
      'DTSTAMP:' + icsDate(new Date().toISOString()),
      'DTSTART:' + icsDate(ev.start),
      'DTEND:' + icsDate(ev.end || ev.start),
      'SUMMARY:' + icsEscape(ev.title),
      'LOCATION:' + icsEscape([ev.venue, ev.address].filter(Boolean).join(', ')),
      'DESCRIPTION:' + icsEscape((ref ? 'Reference ' + ref + '. ' : '') + ev.url),
      'URL:' + ev.url,
      'END:VEVENT', 'END:VCALENDAR'
    ];
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = (ev.handle || 'event') + '.ics';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  function klaviyoPost(path, key, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return true; });
  }

  function klaviyoEvent(cfg, p, profile, extra) {
    var props = Object.assign({
      event_handle: cfg.event.handle, event_name: cfg.event.name, event_title: cfg.event.title,
      event_volume: cfg.event.volume, event_series: cfg.event.series, event_topic: cfg.event.topic,
      event_speaker: cfg.event.speaker, event_start: cfg.event.start, event_end: cfg.event.end,
      event_date: cfg.event.dateLong, event_time: cfg.event.timeRange,
      event_date_poster: (cfg.tokens && cfg.tokens.date) || '',
      event_venue: cfg.event.venue, event_address: cfg.event.address,
      event_url: cfg.event.url, event_gcal_url: cfg.event.gcal,
      status: p.status, reference: p.reference
    }, extra || {});
    return klaviyoPost('events', cfg.klaviyoKey, {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          unique_id: p.reference,
          metric: { data: { type: 'metric', attributes: { name: 'Event RSVP' } } },
          profile: { data: { type: 'profile', attributes: profile } }
        }
      }
    });
  }

  function klaviyoSubscribe(cfg, email) {
    return klaviyoPost('subscriptions', cfg.klaviyoKey, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Event RSVP: ' + cfg.event.name,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.newsletterListId } } }
      }
    });
  }

  function init(root) {
    var cfgEl = root.querySelector('[data-ke-rsvp-config]');
    var form = root.querySelector('[data-ke-rsvp-form]');
    if (!cfgEl || !form) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('RSVP config', e); return; }

    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = btn.querySelector('[data-label]');
    var btnText = btnLabel.textContent;
    var done = root.querySelector('[data-ke-rsvp-done]');
    var lastRef = '';

    /* guest toggle */
    var guest = form.querySelector('[name="guest"]');
    var guestFields = form.querySelector('[data-guest-fields]');
    function syncGuest() {
      if (!guest || !guestFields) return;
      guestFields.hidden = !guest.checked;
      guestFields.querySelectorAll('input').forEach(function (i) {
        i.required = guest.checked && i.getAttribute('data-req') === '1';
        if (!guest.checked) i.value = '';
      });
    }
    if (guest) { guest.addEventListener('change', syncGuest); syncGuest(); }

    /* .ics button */
    var icsBtn = root.querySelector('[data-ke-ics]');
    if (icsBtn) icsBtn.addEventListener('click', function () { downloadIcs(cfg.event, lastRef); });

    function showError(msg) {
      errEl.textContent = msg;
      errEl.hidden = false;
      btn.disabled = false;
      btnLabel.textContent = btnText;
    }

    function showDone(kind, p, ref) {
      var map = Object.assign({}, cfg.tokens || {}, {
        first_name: (p && p.first_name) || '',
        email: (p && p.email) || 'your inbox'
      });
      var h = done.querySelector('[data-done-heading]');
      var tpl = h.getAttribute('data-heading-' + kind) || '';
      h.textContent = fill(map.first_name ? tpl : tpl.replace(/,?\s*\{first_name\}/, ''), map);

      done.querySelector('[data-done-label]').textContent =
        { register: 'Confirmed', waitlist: 'On the waitlist', notify: 'Noted', duplicate: 'Already registered' }[kind] || 'Confirmed';

      var text = done.querySelector('[data-done-text]');
      if (text) {
        text.innerHTML = fill(text.innerHTML, map);
        text.hidden = (kind === 'notify' || kind === 'duplicate');
      }
      var details = done.querySelector('[data-done-details]');
      if (details) details.hidden = (kind === 'notify');
      var refWrap = done.querySelector('[data-done-ref-wrap]');
      if (ref && kind !== 'notify') { done.querySelector('[data-done-ref]').textContent = ref; refWrap.hidden = false; }
      var cal = done.querySelector('[data-done-cal]');
      if (cal) cal.hidden = !(kind === 'register' || kind === 'duplicate');
      lastRef = ref || '';

      /* intro blocks above the form (headings, copy) step aside too */
      var inner = root.closest('.ke-stack__inner');
      var intro = inner ? Array.prototype.filter.call(inner.children, function (el) {
        return el !== root && !el.contains(root) && el.classList.contains('ke-block');
      }) : [];

      function reveal() {
        intro.forEach(function (el) { el.hidden = true; });
        form.hidden = true;
        done.hidden = false;
        if (!REDUCE) {
          void done.offsetWidth;
          done.classList.add('ke-enter');
        }
        try { done.focus({ preventScroll: true }); } catch (e) {}
        var top = (inner || root).getBoundingClientRect().top;
        if (top < headerOffset() || top > window.innerHeight * 0.6) {
          window.scrollTo({ top: Math.max(0, top + window.pageYOffset - headerOffset()), behavior: REDUCE ? 'auto' : 'smooth' });
        }
      }

      if (REDUCE) { reveal(); return; }

      /* 1. fade the form and intro out, holding the current height */
      var startH = root.offsetHeight;
      root.style.height = startH + 'px';
      root.style.overflow = 'hidden';
      form.classList.add('ke-leave');
      intro.forEach(function (el) { el.classList.add('ke-leave'); });

      setTimeout(function () {
        /* 2. swap content, then ease the height to the confirmation's size */
        reveal();
        root.style.height = 'auto';
        var endH = root.offsetHeight;
        root.style.height = startH + 'px';
        void root.offsetHeight;
        root.style.transition = 'height .5s cubic-bezier(.2,.7,.2,1)';
        root.style.height = endH + 'px';
        setTimeout(function () {
          root.style.height = ''; root.style.overflow = ''; root.style.transition = '';
        }, 550);
      }, 320);
    }

    var copyBtn = root.querySelector('[data-done-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var done_ = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(lastRef).then(done_, function () {});
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;

      /* honeypot: pretend it worked */
      if (form.website && form.website.value) { showDone(cfg.mode, {}, ''); return; }

      if (!form.checkValidity()) { form.reportValidity(); return; }

      var fd = new FormData(form);
      var val = function (k) { return String(fd.get(k) || '').trim(); };
      var kind = cfg.mode; /* register | waitlist | notify */
      var status = kind === 'register' ? 'registered' : kind;
      var hasGuest = val('guest') === 'yes' && val('guest_name') !== '';
      var p = {
        type: kind,
        status: status,
        reference: makeRef(cfg.refPrefix),
        submitted_at: new Date().toISOString(),
        event_handle: cfg.event.handle,
        event_name: cfg.event.name,
        first_name: val('first_name'),
        last_name: val('last_name'),
        email: val('email').toLowerCase(),
        phone: val('phone'),
        company: val('company'),
        role: val('role'),
        guest_name: hasGuest ? val('guest_name') : '',
        headcount: kind === 'notify' ? 0 : (hasGuest ? 2 : 1),
        dietary: val('dietary'),
        heard: val('heard'),
        luminaries_opt_in: val('luminaries') === 'yes',
        newsletter_opt_in: val('newsletter') === 'yes',
        newsletter_prechecked: !!cfg.newsletterPrechecked,
        page_url: location.href.split('#')[0]
      };

      btn.disabled = true;
      btnLabel.textContent = 'Sending';

      var sheet = cfg.webhook
        ? fetch(cfg.webhook, { method: 'POST', body: JSON.stringify(p) })
            .then(function (r) { return r.json(); })
            .then(function (j) { return { ok: !!(j && j.ok), data: j || {} }; })
            .catch(function (err) { console.warn('RSVP sheet', err); return { ok: false, data: {} }; })
        : Promise.resolve({ ok: false, data: {}, skipped: true });

      sheet.then(function (res) {
        var dup = res.data && res.data.status === 'duplicate';
        var ref = (res.data && res.data.reference) || p.reference;
        var jobs = [];

        if (!dup && cfg.klaviyoKey) {
          /* Built-in profile fields: role -> Title, company -> Organization.
             Only sent when filled in, so blanks never wipe existing profile data. */
          var profile = { email: p.email };
          if (p.first_name) profile.first_name = p.first_name;
          if (p.last_name) profile.last_name = p.last_name;
          if (p.company) profile.organization = p.company;
          if (p.role) profile.title = p.role;
          profile.properties = {};
          if (p.phone) profile.properties.phone_entered = p.phone;
          if (p.luminaries_opt_in) profile.properties.luminary = true;
          jobs.push(klaviyoEvent(cfg, p, profile, {
            first_name: p.first_name, company: p.company, role: p.role,
            has_guest: hasGuest, guest_name: p.guest_name,
            headcount: p.headcount, dietary: p.dietary, heard: p.heard,
            luminaries_opt_in: p.luminaries_opt_in, newsletter_opt_in: p.newsletter_opt_in
          }));
          if (p.newsletter_opt_in && cfg.newsletterListId) jobs.push(klaviyoSubscribe(cfg, p.email));
        }

        return Promise.all(jobs.map(function (j) { return j.then(function () { return true; }, function (err) { console.warn(err); return false; }); }))
          .then(function (results) {
            var klaviyoOk = results.length > 0 && results[0] === true;
            if (!res.ok && !klaviyoOk && !dup) {
              showError('Sorry, something went wrong. Please try again, or email us to register.');
              return;
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'event_rsvp_submitted',
              event_handle: cfg.event.handle,
              rsvp_status: dup ? 'duplicate' : status,
              attendee_role: p.role,
              has_guest: hasGuest,
              reference: ref
            });
            showDone(dup ? 'duplicate' : kind, p, ref);
          });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-ke-rsvp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
